import { z } from 'zod';

import { idSchema } from '../../../../shared/source/data-contract/id';
import { hardSoftSkillSchema, languageSkillSchema } from '../../../../shared/source/data-contract/skill';
import { proficiencyLevelDetailSchema } from '../../../../shared/source/data-contract/skill-details';

const subSkillSchema = z.object({
    description: z.string(),
    title: z.string(),
});

const focusSkillProficiencyLevelDetailSchema = proficiencyLevelDetailSchema.extend({
    subSkills: subSkillSchema.array().optional(),
});

export const focusSkillProficiencyLevelDetails = focusSkillProficiencyLevelDetailSchema.array();

export type FocusSkillProficiencyLevelDetail = z.infer<typeof focusSkillProficiencyLevelDetailSchema>;

const focusHardSoftSkillSchema = hardSoftSkillSchema.extend({
    alignmentRecordId: idSchema.optional(),
    context: z.string().optional(),
    createdAt: z.iso.datetime().optional(),
    description: z.string().optional(),
    proficiencyLevelDetails: focusSkillProficiencyLevelDetails.optional(),
});
const focusLanguageSkillSchema = languageSkillSchema.extend({
    alignmentRecordId: idSchema.optional(),
    context: z.string().optional(),
    createdAt: z.iso.datetime().optional(),
    description: z.string().optional(),
    proficiencyLevelDetails: focusSkillProficiencyLevelDetails.optional(),
});

export const focusSkillSchema = z.union([focusHardSoftSkillSchema, focusLanguageSkillSchema]);

export type FocusSkill = z.infer<typeof focusSkillSchema>;
